import React from "react";
import "./GalleryGrid.css";
import weddingCeremonyOutside from "../images/wedding-ceremony-outside.avif";
import chattersWeddingTables from "../images/chatters-wedding-tables.avif";
import weddingTablesMarquee from "../images/wedding-tables-marquee.avif";
import chattersPavlova from "../images/chatters-pavlova.avif";
import heritageTomatoSaladGarden from "../images/heritage-tomato-salad-garden.avif";
import chattersPhone from "../images/chatters-phone.avif";
import chattersBiscuitTerrine from "../images/chatters-biscuit-terrine.avif";
import canapes from "../images/canapes.avif";
import castleLochlanWeddingTopTableEmpty from "../images/castle-lochlan-wedding-top-table-empty.avif";
import castleLochlanWeddingTables from "../images/castle-lochlan-wedding-tables.avif";
import weddingTopTablePiper from "../images/wedding-top-table-piper.avif";
import fullSavouryBuffet from "../images/full-savoury-buffet.avif";
import potatoSalad from "../images/potato-salad.avif";
import saladAndPestoPasta from "../images/salad-and-pesto-pasta.avif";
import staff from "../images/staff.avif";
import appleFennelSalads from "../images/apple-fennel-salads.avif";
import frenchBeanSalads from "../images/french-bean-salads.avif";
import weddingChatters from "../images/wedding-chatters.avif";
import puddingTrolleyEaten from "../images/pudding-trolley-eaten.avif";
import vignarolaSalad from "../images/vignarola-salad.avif";
import salad from "../images/salad.avif";
import chattersCheeseBoard from "../images/chatters-cheese-board.avif";
import chattersGardenSittingDark from "../images/chatters-garden-sitting-dark.avif";
import chattersMenus from "../images/chatters-menus.avif";
import chattersSittingGarden from "../images/chatters-sitting-garden.avif";
import chattersWindowRed from "../images/chatters-window-red.avif";
import chattersWineWindow from "../images/chatters-wine-window.avif";
import wineBottles from "../images/wine-bottles.avif";
import chattersMirror from "../images/chatters-mirror.avif";
import crispyTortellini from "../images/crispy-tortellini.avif";
import curedTroutKohlrabi from "../images/cured-trout-kohlrabi.avif";
import cheeseCourse from "../images/cheese-course.avif";
import lemonPosset from "../images/lemon-posset.avif";

const galleryItems = [
    { src: chattersWindowRed },
    { src: crispyTortellini },
    { src: chattersGardenSittingDark },
    { src: weddingTablesMarquee },
    { src: cheeseCourse },
    { src: heritageTomatoSaladGarden },
    { src: chattersPhone },
    { src: chattersBiscuitTerrine },
    { src: canapes },
    { src: chattersSittingGarden },
    { src: wineBottles },
    { src: weddingTopTablePiper },
    { src: fullSavouryBuffet },
    { src: potatoSalad },
    { src: lemonPosset },
    { src: staff },
    { src: appleFennelSalads },
    { src: chattersMenus },
    { src: weddingChatters },
    { src: vignarolaSalad },
    { src: chattersWeddingTables },
    { src: salad },
    { src: chattersCheeseBoard },
    { src: castleLochlanWeddingTopTableEmpty },
    { src: weddingCeremonyOutside },
    { src: chattersWineWindow },
    { src: puddingTrolleyEaten },
    { src: castleLochlanWeddingTables },
    { src: chattersMirror },
    { src: curedTroutKohlrabi },
    { src: frenchBeanSalads },
    { src: chattersPavlova },
    { src: saladAndPestoPasta },
];

const GalleryGrid = () => {
    return (
        <div className="gallery-masonry">
            {galleryItems.map((item, index) => (
                <div className="gallery-item">
                    <img src={item.src} alt={`Gallery item ${index + 1}`} loading="lazy" />
                </div>
            ))}
        </div>
    );
};

export default GalleryGrid;
